import { Box,Divider} from "@mui/material";
import MyLabel from "../../components/myLabel";
import Styles from "./styles";
import PersonalVideoIcon from '@mui/icons-material/PersonalVideo';
  
const MyCardboard = ({titulo, color, valor, Icone, subtitulo, subtitulocor}) => {
    
    let panelColor = color ? color : 'rgb(73, 163, 241)'
    let styles = Styles(panelColor)

    subtitulocor = subtitulocor ? subtitulocor : 'rgb(123, 128, 154)'
    valor = valor ? valor : 'valor'
    titulo = titulo ? titulo : 'titulo'
    subtitulo = subtitulo ? subtitulo : 'subtitulo'    

  return (
            <Box sx={styles.card}>
                    <Box  sx={{...styles.icon,backgroundColor: panelColor}} >
                        {
                            //passar objeto react com letra inicial maiuscula para que possa ser reconhecido.
                            Icone ? 
                                <Icone fontSize="large"  sx={{color:'white'}} />
                            :
                            <PersonalVideoIcon fontSize="large"  sx={{color:'white'}}/>
                        }
                    </Box>
                    <Box sx={styles.centerArea}>
                        <Box sx={styles.informationArea}>
                            <MyLabel sx={{...styles.subtitle,color: panelColor}} component='p' text = {titulo}/>
                            <MyLabel sx={{color: panelColor}} component='p' text = {valor}/>
                        </Box>
                    </Box>
                    <Divider />
                    <Box sx={styles.footerArea}>
                        <MyLabel sx={{fontSize: '0.875rem', fontWeight: '300', color:subtitulocor }} component='p' text = {subtitulo}/>
                    </Box>
            </Box>
        
  );
};
export default MyCardboard;
